// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b7e65b09","453":"d69932a4","667":"21a5acc5","977":"9cb0005a"}[chunkId] + ".chunk.js";
};